export function formatSpecs (
  selectSkuKey: string,
  specs: ProductV3.Specs[],
  skus: ProductV3.Sku[],
  skuActivateInfo?: ProductV3.SelectedSkuActivity
) {
  const selectSkuKeys = selectSkuKey.split(';')
  const handleSkuKeys = selectSkuKeys.reduce<{ handleIdx: number, keys: string[] }[]>((pre, cur, index) => {
    pre.push({
        handleIdx: index,
        keys: selectSkuKeys.filter((_, i) => i !== index)
    })

    return pre
  }, [])

  const handleSkus = handleSkuKeys.map(({ handleIdx, keys }) => {
    return skus.filter(sku => {
        let inSku = true

        for(let i = 0; i < keys.length; i++) {
          inSku = sku.key.indexOf(keys[i]) >= 0
          if(!inSku) {break}
        }
        

        return inSku
    })
  })

  const isHandle: { [key: string]: number } = {}
  handleSkus.forEach((_skus, index) => {
    const spec = specs[index]

    _skus.forEach((handleSku) => {
      const _skuKeys = handleSku.key.split(';')

      spec.values.forEach((value, i) => {
        const curSpecKey = `${spec.pid}:${value.pvid}`

        if(_skuKeys.find(skuKey => skuKey === curSpecKey)) {          
          if(!isHandle[curSpecKey] || value.temporaryDisabled === true) {
            let _inventory = handleSku.inventory

            if(handleSku.skuId === skuActivateInfo?.skuId) {
              // 秒杀活动需要使用秒杀活动库存
              if(skuActivateInfo?.activityType === 1 && skuActivateInfo?.flashSale?.status === 1) {
                _inventory = skuActivateInfo.flashSale.inventory
              }
            }

            const { gsAvailable, dsAvailable, fbkAvailable } = _inventory
            value.temporaryDisabled = !((Math.max(gsAvailable, dsAvailable, fbkAvailable)) > 0 && handleSku.status !== -1)
          }

          isHandle[curSpecKey] = 1
        }
      })
    })
  })
}
